export const APP_STORE_URL = "https://apps.apple.com/us/app/fieldz-ai/id6759849207";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.fieldzai.app";

const shell =
  "h-11 px-4 rounded-xl flex items-center gap-2.5 bg-slate-900 border border-slate-700/60 transition-transform duration-200 hover:-translate-y-0.5";

export const AppStoreBadge = () => (
  <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className={shell} data-testid="appstore-badge">
    <svg viewBox="0 0 24 24" fill="white" className="w-5 h-5">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
    </svg>
    <div className="leading-none text-left">
      <p className="text-white/60 text-[8px]">Download on the</p>
      <p className="text-white font-semibold text-[13px]">App Store</p>
    </div>
  </a>
);

export const GooglePlayBadge = () => (
  <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className={shell} data-testid="playstore-badge">
    <svg viewBox="0 0 24 24" className="w-5 h-5">
      <path d="M3.61 1.814L13.793 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.61-.92z" fill="#4285F4" />
      <path d="M16.828 8.967L5.416.932C4.87.607 4.26.48 3.688.594l10.105 10.103 3.035-1.73z" fill="#EA4335" />
      <path d="M16.828 15.033l-3.035-1.73L3.688 23.406c.573.114 1.183-.013 1.728-.338l11.412-8.035z" fill="#34A853" />
      <path d="M20.322 10.46l-3.494-1.493-3.035 3.035 3.035 3.035 3.494-1.534a1.98 1.98 0 000-3.043z" fill="#FBBC05" />
    </svg>
    <div className="leading-none text-left">
      <p className="text-white/60 text-[8px]">Get it on</p>
      <p className="text-white font-semibold text-[13px]">Google Play</p>
    </div>
  </a>
);
